const template = {
  name: "Default JCT MW 2024 v1.0 19/01/2026",
  isSystemDefault: false,
  isGlobal: true,
  companies: [],
  resources: [
    {
      id: 1,
      type: "TEXT",
      key: "SUPPLIER_NAME",
      value: "Contractor"
    },
    {
      id: 2,
      type: "TEXT",
      key: "SUPPLIER_ABBREVIATION",
      value: "CON"
    },
    {
      id: 3,
      type: "TEXT",
      key: "PM_NAME",
      value: "Architect/Contract Administrator"
    },
    {
      id: 4,
      type: "TEXT",
      key: "PM_ABBREVIATION",
      value: "A/CA"
    },
    {
      id: 7,
      type: "TEXT",
      key: "CLIENT_NAME",
      value: "Employer"
    },
    {
      id: 8,
      type: "NUMBER",
      key: "SUPPLIER_REPLY_PERIOD",
      value: 7
    },
    {
      id: 9,
      type: "NUMBER",
      key: "PM_REPLY_PERIOD",
      value: 7
    },
    {
      id: 10,
      type: "NUMBER",
      key: "QUOTE_DURATION",
      value: 21
    },
    {
      id: 13,
      type: "NUMBER",
      key: "REQUOTE_DURATION",
      value: 21
    },
    {
      id: 11,
      type: "NUMBER",
      key: "QUOTE_RESPONSE",
      value: 14
    },
    {
      id: 14,
      type: "NUMBER",
      key: "REQUOTE_RESPONSE",
      value: 14
    },
    {
      id: 12,
      type: "NUMBER",
      key: "VARIATION_RESPONSE",
      value: 7
    },
    {
      id: 16,
      type: "NUMBER",
      key: "PROGRAMME_REPLY_PERIOD",
      value: 14
    },
    {
      id: 5,
      type: "TEXT",
      key: "SUPERVISOR_NAME",
      value: "Quantity Surveyor"
    },
    {
      id: 8,
      type: "TEXT",
      key: "CLIENT_ABBREVIATION",
      value: "EMP"
    },
    {
      id: 6,
      type: "TEXT",
      key: "SUPERVISOR_ABBREVIATION",
      value: "QS"
    },
    {
      id: 26,
      type: "NUMBER",
      key: "CLIENT_REPLY_PERIOD",
      value: 7
    },
    {
      id: 27,
      type: "NUMBER",
      key: "SUPERVISOR_REPLY_PERIOD",
      value: 7
    }
  ],
  workflowGroups: [
    {
      id: 102,
      title: "Instructions",
      workflows: [
        {
          id: 4,
          title: "A/CA Instruction",
          notificationName: "Instruction",
          abbreviation: "$PM_ABBREVIATION-Instruction-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "InstructionTypes",
          values: [
            {
              id: 2,
              isActive: false,
              field: "",
              display: "2.1.3.2 Direction for the integration of the Contractor's design with the design of the whole of the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              isActive: true,
              field: "",
              display: "2.3 providing further information",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "2.9 To not correct an error in setting out",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "",
              display: "2.11.1 necessary to enable the $SUPPLIER_NAME to carry out the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "",
              display: "2.12.2 to correct errors in the Bill of Quantities",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "",
              display: "2.13.1 To correct a departure, error or omission",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "2.15.2 To correct a divergence between Statutory Requirements and a Contract Document",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: false,
              field: "",
              display: "2.30 not to make good defects",
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              isActive: true,
              field: "",
              display: "3.6 permitted by the Contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "3.7 To expend a provisional sum",
              overrideResources: null,
              postActions: null
            },
            {
              id: 34,
              isActive: true,
              field: "",
              display: "3.8 To exclude a person from site",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: false,
              field: "",
              display: "3.12 To postpone works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              isActive: false,
              field: "",
              display: "3.14 To open work up for inspection or carry out any tests",
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              isActive: false,
              field: "",
              display: "3.15.1 To open work up for inspection or carry out any tests (work not in accordance with the Contract)",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: false,
              field: "",
              display: "3.16.1 To remove work, materials or goods which are not in accordance with the Contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              isActive: false,
              field: "",
              display: "3.16.2 As a consequence of work not carried out in a proper and workmanlike manner",
              overrideResources: null,
              postActions: null
            },
            {
              id: 22,
              isActive: false,
              field: "",
              display: "6.5.1 To take out and maintain insurance for the liability of the $CLIENT_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 23,
              isActive: false,
              field: "",
              display: "6.10.4 On behalf of the $CLIENT_NAME not to renew Terrorism Cover",
              overrideResources: null,
              postActions: null
            },
            {
              id: 24,
              isActive: false,
              field: "",
              display: "6.17.1.2 To carry out Remedial Measures",
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              isActive: false,
              field: "",
              display: "Sch. 2.2 In connection with a Named Subcontractor's appointment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              isActive: false,
              field: "",
              display: "Sch. 2.4 That the work is carried out by someone other than the Named Subcontractor",
              overrideResources: null,
              postActions: null
            },
            {
              id: 27,
              isActive: false,
              field: "",
              display: "Sch. 2.7 in connection with the termination of a Named Subcontractor's employment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 29,
              isActive: true,
              field: "",
              display: "Sch. 2.2.3 In connection with a value engineering submission",
              overrideResources: null,
              postActions: null
            },
            {
              id: 28,
              isActive: true,
              field: "",
              display: "Other Instruction",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PM",
              display: "$PM_NAME Instructions awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Client",
              display: "$CLIENT_NAME Instructions awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Supervisor",
              display: "$SUPERVISOR_NAME Instructions awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 104,
      title: "Programme",
      workflows: [
        {
          id: 14,
          title: "$SUPPLIER_NAME Programme",
          notificationName: "Programme",
          abbreviation: "$SUPPLIER_ABBREVIATION-Programme-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PROGRAMME_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "ReasonLabel",
              display: "Reason for any change to planned completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ChangeLabel",
              display: "Change in any other important project milestone in period and reasons why",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "MainProgressLabel",
              display: "Main progress achieved in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "KeyActivitiesLabel",
              display: "Key activities forecast in next four weeks",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "SummaryLabel",
              display: "Summary of critical path",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "ChangesLabel",
              display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "CompensationLabel",
              display: "Variations added to programme this period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NotificationClause",
              display: "Please find attached programme for acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ReplyRejectReasonLabel",
              display: "The $SUPPLIER_NAME’s programme is not accepted for the following reasons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "ReplyNotificationClause",
              display: "In accordance with NEC4 PSC clause 31.3 you are notified that the $SUPPLIER_NAME’s Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "ReplyNotificationClause",
              display: "You are notified that the $SUPPLIER_NAME’s Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "DashboardPlannedCompletionLabel",
              display: "Planned Completion Date",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$SUPPLIER_NAME Programme Submission awaiting Acceptance",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyRejectOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "plansnotpractical",
              display: "The $SUPPLIER_NAME’s plans which it shows are not practicable",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "missingcontractrequires",
              display: "It does not show the information which this contract requires",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "notrepresentplan",
              display: "It does not represent the $SUPPLIER_NAME’s plans realistically",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "notcomply",
              display: "It does not comply with the Works Information",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Fields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PreviousPlanned",
              display: "Previous Planned Completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PlannedCompletion",
              display: "Date of Planned Completion this period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Reason",
              display: "Reason for any change to Planned Completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Change",
              display: "Change in any other Key Date, Sectional Completion or other important project milestone in period and reasons why",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "MainProgress",
              display: "Main progress achieved in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "KeyActivities",
              display: "Key activities forecast in next four weeks",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "Summary",
              display: "Summary of critical path",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "Changes",
              display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "Compensation",
              display: "Compensation events added to programme this period",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 105,
      title: "Notifications",
      workflows: [
        {
          id: 15,
          title: "A/CA Notifications",
          notificationName: "Notification",
          abbreviation: "$PM_ABBREVIATION-Notification-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 16,
          title: "$SUPPLIER_NAME Notifications",
          notificationName: "Notification",
          abbreviation: "$SUPPLIER_ABBREVIATION-Notification-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "SupplierClauses",
          values: [
            {
              id: 50,
              isActive: false,
              field: "",
              display: "1.7 of an agreement of a method of communication",
              overrideResources: null,
              postActions: null
            },
            {
              id: 51,
              isActive: true,
              field: "",
              display: "1.6.2.2  of an address to receive communications",
              overrideResources: null,
              postActions: null
            },
            {
              id: 52,
              isActive: false,
              field: "",
              display: "2.1.1 required by statute",
              overrideResources: null,
              postActions: null
            },
            {
              id: 57,
              isActive: true,
              field: "",
              display: "2.5.1 of a divergence between the Statutory Requirements and a Contract Document",
              overrideResources: null,
              postActions: null
            },
            {
              id: 61,
              isActive: false,
              field: "",
              display: "2.6.1 of submission to use or occupy the site or the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 62,
              isActive: false,
              field: "",
              display: "2.6.2 of the amount of additional insurance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 98,
              isActive: true,
              field: "",
              display: "2.7 of a delay to completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 53,
              isActive: false,
              field: "",
              display: "2.10.1 of Contractor's Design Documents",
              overrideResources: null,
              postActions: null
            },
            {
              id: 54,
              isActive: false,
              field: "",
              display: "2.11.3 of further information to explain and amplify the Contract Drawings",
              overrideResources: null,
              postActions: null
            },
            {
              id: 55,
              isActive: false,
              field: "",
              display: "2.11.3 of the time by which further information is requried",
              overrideResources: null,
              postActions: null
            },
            {
              id: 56,
              isActive: false,
              field: "",
              display: "2.13.3.1 of a departure, error or omission",
              overrideResources: null,
              postActions: null
            },
            {
              id: 58,
              isActive: false,
              field: "",
              display: "2.16.2 of emergency compliance work",
              overrideResources: null,
              postActions: null
            },
            {
              id: 59,
              isActive: false,
              field: "",
              display: "2.19.1 that the progress of the Works or a Section is or is likely to be delayed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 60,
              isActive: false,
              field: "",
              display: "2.32 of information in connection with CDM, Contractor's Design Documents and Designed Portion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 66,
              isActive: false,
              field: "",
              display: "3.4.1 of reasonable objection to the nomination of a replacement Architect/Contract Administrator or Quantity Surveyor",
              overrideResources: null,
              postActions: null
            },
            {
              id: 67,
              isActive: false,
              field: "",
              display: "3.8.1 of a reasonable objection to an instruction",
              overrideResources: null,
              postActions: null
            },
            {
              id: 68,
              isActive: false,
              field: "",
              display: "3.8.2 that an instruction or direction adversely affects the Contractor's Design or compliance with CDM",
              overrideResources: null,
              postActions: null
            },
            {
              id: 63,
              isActive: false,
              field: "",
              display: "3.10 of a request to demonstrate that an instruction complies with the Contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 64,
              isActive: false,
              field: "",
              display: "3.15.1 of the actions proposed to be taken in respect of work, materials and goods not in accordance with the Contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 65,
              isActive: false,
              field: "",
              display: "3.15.2 of objection to an instruction under 3.15.1",
              overrideResources: null,
              postActions: null
            },
            {
              id: 79,
              isActive: false,
              field: "",
              display: "4.7 of an advance payment bond",
              overrideResources: null,
              postActions: null
            },
            {
              id: 69,
              isActive: false,
              field: "",
              display: "4.10.2 of proof that propery of the Listed Items is vested in the Contractor and is insured",
              overrideResources: null,
              postActions: null
            },
            {
              id: 70,
              isActive: false,
              field: "",
              display: "4.10.5 of a bond for payment of Listed Items",
              overrideResources: null,
              postActions: null
            },
            {
              id: 71,
              isActive: true,
              field: "",
              display: "4.6.1 of the issue of a payment notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 72,
              isActive: true,
              field: "",
              display: "4.6.4 of the issue of a Pay Less Notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 73,
              isActive: true,
              field: "",
              display: "4.8.1 Of an intention to suspend performance of all or part of the works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 75,
              isActive: false,
              field: "",
              display: "4.16.1 That the effect of a Relevant Matter on the regular progress of the works is likely to incur loss and/or expense",
              overrideResources: null,
              postActions: null
            },
            {
              id: 76,
              isActive: false,
              field: "",
              display: "4.16.2 of an initial assessment of loss and/or expense",
              overrideResources: null,
              postActions: null
            },
            {
              id: 77,
              isActive: false,
              field: "",
              display: "4.16.3 of further information in support of the assessment of loss and/or expense",
              overrideResources: null,
              postActions: null
            },
            {
              id: 78,
              isActive: false,
              field: "",
              display: "4.20.1 of information for the final account",
              overrideResources: null,
              postActions: null
            },
            {
              id: 80,
              isActive: false,
              field: "",
              display: "5.4 of vouchers for work carried out on daywork",
              overrideResources: null,
              postActions: null
            },
            {
              id: 81,
              isActive: false,
              field: "",
              display: "6.11.1 that Terrorism Cover will cease",
              overrideResources: null,
              postActions: null
            },
            {
              id: 82,
              isActive: true,
              field: "",
              display: "5.7 of a request to  provide evidence of insurance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 83,
              isActive: false,
              field: "",
              display: "6.12.1 of evidence of insurance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 84,
              isActive: true,
              field: "",
              display: "5.8.1 of loss or damage caused by an insured risk",
              overrideResources: null,
              postActions: null
            },
            {
              id: 86,
              isActive: false,
              field: "",
              display: "6.17.1 of a breach of the Joint Fire Code",
              overrideResources: null,
              postActions: null
            },
            {
              id: 97,
              isActive: false,
              field: "",
              display: "6.17.1.2 of emergency compliance work",
              overrideResources: null,
              postActions: null
            },
            {
              id: 89,
              isActive: false,
              field: "",
              display: "6.20 that insurance has ceased to be available at commercially reasonable rates",
              overrideResources: null,
              postActions: null
            },
            {
              id: 90,
              isActive: false,
              field: "",
              display: "7.2 of a performance bond or guarantee",
              overrideResources: null,
              postActions: null
            },
            {
              id: 91,
              isActive: false,
              field: "",
              display: "Sch. 2.1 of the date of entering into a subcontract with a Named Subcontractor",
              overrideResources: null,
              postActions: null
            },
            {
              id: 92,
              isActive: false,
              field: "",
              display: "Sch. 2.2 that the Contractor is unable to enter into subcontract with a Named Subcontractor",
              overrideResources: null,
              postActions: null
            },
            {
              id: 93,
              isActive: false,
              field: "",
              display: "Sch. 2.6 of events leading to a termination of the Named Subcontractor's subcontract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 94,
              isActive: false,
              field: "",
              display: "Sch. 2.7 of the circumstances surrounding a Named Subcontractor's termination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 95,
              isActive: false,
              field: "",
              display: "Sch. 5.2 of information necessary to monitor and assess the Contractor's performance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 96,
              isActive: false,
              field: "",
              display: "Sch. 5.7 of a disagreement with a reply to a submission of a design document",
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              isActive: true,
              field: "",
              display: "Other notification",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SupervisorClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "3.4 of a Direction",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ClientClauses",
          values: [
            {
              id: 2,
              isActive: false,
              field: "",
              display: "1.7.2 of an agreement of a method of communication",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "1.6.2.2 of an address to receive communications",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "2.1.3 to provide information about the environmental impact of the supply of materials and goods",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "2.8.1 that the Employer may require payment of liquidated damages",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "2.8.2 of the amount of liquidated damages payable",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "",
              display: "2.6.1 of submission to use or occupy the site or the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "3.4.1 of the nomination of a replacement Architect/Contract Administrator or Quantity Surveyor",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "",
              display: "4.6.4 of the issue of a Pay Less Notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "6.11.1 that Terrorism Cover will cease",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: false,
              field: "",
              display: "6.11.2 on connection with cessation of Terrorism Cover",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: false,
              field: "",
              display: "6.11.3 to effect and maintain alternative Terrorism Cover",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "",
              display: "5.7 of a request to  provide evidence of insurance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: false,
              field: "",
              display: "6.17.1 of a breach of the Joint Fire Code",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "Sch 2.3.3 that performance targets may not be met",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "PmClauses",
          values: [
            {
              id: 16,
              isActive: true,
              field: "",
              display: "2.7 of a reasonable extension to the time for Completion of the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: true,
              field: "",
              display: "2.9 of the issue of a Practical or Sectional Completion Certificate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "",
              display: "2.11 of the issue of a certificate of making good defects for the works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "3.5 that the Contractor is required to comply with an instruction",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "3.10 of the provision empowering the issue of an instruction",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "",
              display: "4.9.2 of the issue of the Final Certificate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "15.1 we have become aware of the following ambiguity/inconsistency:",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "17.1 we have become aware of the following matter that would either be illegal or impossible:",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "",
              display: "21.3 we provide the following forecasts of expenses",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "62.6 the Client has not responded to a compensation event quotation within the timescales outlined in the contract as detailed below:",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "64.4 the Client has not made their own assessment of a compensation event quotation within the timescales outlined in the contract as detailed below:",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "81.1/2 the following insurances/insurance certificates have been provided by the Consultant:",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: false,
              field: "",
              display: "90.1: we wish to terminate the contract for the reasons/detail listed below",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: false,
              field: "",
              display: "X1.1: the following price adjustment factor",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: false,
              field: "",
              display: "X4.1: the following guarantee from the parent company",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "other general notification",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 106,
      title: "Submissions",
      workflows: [
        {
          id: 18,
          title: "$SUPPLIER_NAME Submissions",
          notificationName: "Submission",
          abbreviation: "$SUPPLIER_ABBREVIATION-Submission-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 49,
          title: "$PM_NAME Submissions",
          notificationName: "Submission",
          abbreviation: "$PM_ABBREVIATION-Submission-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "IssueClauses",
          values: [
            {
              id: 57,
              isActive: true,
              field: "",
              display: "2.1.2 of a economically viable amendment to the works to make an environmental improvement",
              overrideResources: null,
              postActions: null
            },
            {
              id: 53,
              isActive: true,
              field: "",
              display: "2.1.3 of information about the environmental impact of the supply of materials and goods",
              overrideResources: null,
              postActions: null
            },
            {
              id: 29,
              isActive: true,
              field: "",
              display: "2.1.4  of quality of materials, goods or workmanship",
              overrideResources: null,
              postActions: null
            },
            {
              id: 50,
              isActive: false,
              field: "",
              display: "2.6.1 for consent to use or occupy the site or the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 51,
              isActive: false,
              field: "",
              display: "2.7.2 for consent for work to be carried out by the Employer",
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              isActive: false,
              field: "",
              display: "2.10.1 of a proposal to vary times in the Information Release Schedule",
              overrideResources: null,
              postActions: null
            },
            {
              id: 58,
              isActive: false,
              field: "",
              display: "2.10.1 of Contractor's Design Documents",
              overrideResources: null,
              postActions: null
            },
            {
              id: 59,
              isActive: false,
              field: "",
              display: "2.11.1 of further information to explain and amplify the Contract Drawings",
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              isActive: false,
              field: "",
              display: "2.13.3.2 of a proposal to amend a departure, error or omission in the Contractor's Proposals or Design Documents",
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              isActive: false,
              field: "",
              display: "2.15.1 of a proposal to correct a divergence between the Statutory Requirements and the Contractor's Proposals or Design Documents",
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              isActive: false,
              field: "",
              display: "2.17 for consent to remove materials and goods from site",
              overrideResources: null,
              postActions: null
            },
            {
              id: 52,
              isActive: false,
              field: "",
              display: "2.25 for consent for the Employer to take possession of part of the works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 54,
              isActive: false,
              field: "",
              display: "2.32 of information in connection with CDM, Contractor's Design Documents and Designed Portion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 34,
              isActive: true,
              field: "",
              display: "3.3.1 for consent to subcontract the whole or part of the works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 35,
              isActive: false,
              field: "",
              display: "4.7 for approval of a surety for an advance payment bond",
              overrideResources: null,
              postActions: null
            },
            {
              id: 63,
              isActive: true,
              field: "",
              display: "4.9.1 of information for the final account",
              overrideResources: null,
              postActions: null
            },
            {
              id: 60,
              isActive: false,
              field: "",
              display: "4.10.2 of proof that property of the Listed Items is vested in the Contractor and is insured",
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              isActive: false,
              field: "",
              display: "4.10.5 for approval of a surety for payment of Listed Items",
              overrideResources: null,
              postActions: null
            },
            {
              id: 61,
              isActive: false,
              field: "",
              display: "4.16.2 of an initial assessment of loss and/or expense",
              overrideResources: null,
              postActions: null
            },
            {
              id: 62,
              isActive: false,
              field: "",
              display: "4.16.3 of further information in support of the assessment of loss and/or expense",
              overrideResources: null,
              postActions: null
            },
            {
              id: 55,
              isActive: false,
              field: "",
              display: "5.4 of vouchers for work carried out on daywork",
              overrideResources: null,
              postActions: null
            },
            {
              id: 64,
              isActive: true,
              field: "",
              display: "5.7 of evidence of insurance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 42,
              isActive: false,
              field: "",
              display: "7.1 for consent to assign the Contract or any rights thereunder",
              overrideResources: null,
              postActions: null
            },
            {
              id: 56,
              isActive: false,
              field: "",
              display: "7.2 of a performance bond or guarantee",
              overrideResources: null,
              postActions: null
            },
            {
              id: 43,
              isActive: false,
              field: "",
              display: "Sch.1.A1 for approval of insurers for the All Risks Policy",
              overrideResources: null,
              postActions: null
            },
            {
              id: 44,
              isActive: false,
              field: "",
              display: "Sch. 2.6 for consent to accept termination or repudiation of a Named Subcontractor's subcontract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 45,
              isActive: false,
              field: "",
              display: "Sch. 2.10.2 for an agreement that the Employer shall indemnify the Contractor against legal costs",
              overrideResources: null,
              postActions: null
            },
            {
              id: 46,
              isActive: true,
              field: "",
              display: "Sch. 2.2.2 of proposed changes to designs and specifications for the purpose of value engineering",
              overrideResources: null,
              postActions: null
            },
            {
              id: 49,
              isActive: true,
              field: "",
              display: "Sch 2.3.2 of information necessary to monitor and assess the Contractor's performance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 48,
              isActive: true,
              field: "",
              display: "Sch. 2.3.3 of proposals to improve performance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 47,
              isActive: false,
              field: "",
              display: "Sch. 5.4.1 of proposed changes to improve environmental performance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 28,
              isActive: true,
              field: "",
              display: "Other submission",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$SUPPLIER_NAME Submission awaiting Acceptance",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "IssueClausesPM",
          values: [
            {
              id: 7,
              isActive: false,
              field: "",
              display: "2.1 of information required in the Information Release Schedule",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: false,
              field: "",
              display: "2.8.2 of copies of the Contract Documents",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "2.9 of dimensioned drawings to set out the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "2.10.1 to vary times in the Information Release Schedule",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "2.30 to not make good defects",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "2.6.1 of a request to use or occupy the site or the Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "2.7.2 of a request on behalf of the Employer to execute its own works on site",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "",
              display: "2.9.1 of provision of schedules and similar documents",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "",
              display: "5.7 of evidence of insurance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "",
              display: "6.12.1 of evidence of insurance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "Other submission",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 103,
      title: "Variations and Extension of Time",
      workflows: [
        {
          id: 50,
          title: "Extension of Time",
          notificationName: "Variation",
          abbreviation: "Variation-Time-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 51,
          title: "Variations and other changes to the Contract Sum",
          notificationName: "Variation",
          abbreviation: "Variation-Price-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmAssumptionLabel",
              display: "The following assumptions shall be considered",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PmAssumptionNote",
              display: "You are hereby instructed to provide a quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "SupplierDescNote",
              display: "In accordance with the contract I notify you that the event described below has happened which: We believe is a variation, has happened less than 5 weeks since we became aware of the event, you have not notified to us.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "ReplyAcceptedCommentLabel",
              display: "In accordance with the contract you are notified that the issue flagged is a Variation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "ReplyRejectedCommentLabel",
              display: "In accordance with the contract you are notified that the $SUPPLIER_NAME Notification is not a Variation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "ReplyAcceptedAssumptionLabel",
              display: "In accordance with the contract the following assumptions shall be considered",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "QuoteNote",
              display: "In accordance with the contract please find attached our quotation for $reference",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "ExtensionPMLabel",
              display: "We require an extension to the contractual time to produce a quotation response as detailed below for the following reasons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ExtensionSupplierLabel",
              display: "We require an extension to the contractual time to produce a quotation as detailed below for the following reasons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "AssessmentDetailLabel",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "ProposedInstructionNote",
              display: "In accordance with the contract you are instructed to provide a quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "ProposedInstructionLabel",
              display: "In accordance with the contract he following assumptions shall be considered",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "ReplyRejectedOptionsLabel",
              display: "I have decided that the Notification",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "QuoteCostEffectLabel",
              display: "Cost Increase/Decrease",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "QuoteDateEffectLabel",
              display: "Extension of time required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "QuoteDaysEffectLabel",
              display: "Extension of time required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "AssessmentCostEffectLabel",
              display: "Cost Increase/Decrease",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              isActive: true,
              field: "AssessmentDaysEffectLabel",
              display: "Number of days effect to the completion date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "CompensationTypeLabel",
              display: "Variation types",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              isActive: true,
              field: "QuoteProgrammeAttachLabel",
              display: "Are you attaching a programme showing the effect against the last Accepted Programme with this quotation?",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "AssessmentCompensationLabel",
              display: "Variation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 22,
              isActive: true,
              field: "AssessmentWarningBanner",
              display: "",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: false,
              field: "PmCompensationAQ",
              display: "Variations notified by $PM_ABBREVIATION awaiting quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "PmCompensationARQ",
              display: "Variations notified by $PM_ABBREVIATION awaiting revised quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "PmCompensationAPMRQ",
              display: "Variations notified by $PM_ABBREVIATION awaiting response to quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "PmCompensationAPMA",
              display: "Variations notified by $PM_ABBREVIATION awaiting $PM_ABBREVIATION Assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "SupCompensationAQ",
              display: "Variations notified by $SUPPLIER_NAME awaiting quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SupCompensationARQ",
              display: "Variations notified by $SUPPLIER_NAME awaiting revised quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "SupCompensationAPMR",
              display: "Variations notified by $SUPPLIER_NAME awaiting $PM_ABBREVIATION response",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "SupCompensationAPMRQ",
              display: "Variations notified by $SUPPLIER_NAME awaiting response to quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "SupCompensationAPMA",
              display: "Variations notified by $SUPPLIER_NAME awaiting $PM_ABBREVIATION Assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "PmProposedAQ",
              display: "Proposed Variations awaiting quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "PmProposedARQ",
              display: "Proposed Variations awaiting revised quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "PmProposedAPMRQ",
              display: "Proposed Variations awaiting response to quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "PmProposedAPMA",
              display: "Proposed Variations awaiting $PM_ABBREVIATION Assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "PmExtension",
              display: "$PM_ABBREVIATION Quote Response Extensions awaiting Acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "SupExtension",
              display: "$SUPPLIER_NAME Quote Extensions awaiting Acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "SupAssumption",
              display: "$SUPPLIER_NAME Assumptions awaiting Acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "SupClaimAQ",
              display: "Claims notified by $SUPPLIER_NAME awaiting quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "SupClaimARQ",
              display: "Claims notified by $SUPPLIER_NAME awaiting revised quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "SupClaimAPMRQ",
              display: "Claims notified by $SUPPLIER_NAME awaiting response to quotes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              isActive: true,
              field: "SupClaimAPMA",
              display: "Claims notified by $SUPPLIER_NAME awaiting $PM_ABBREVIATION Assessment",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyRejectOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "faultpscp",
              display: "Arises from a fault of the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "notexpectnothappen",
              display: "Has not happened and is not expected to happen",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "noteffectcostcompletion",
              display: "Has no effect on Defined Cost, Completion or meeting a Key Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "statedcontract",
              display: "Is not one of the variations stated in this contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "notnotifiedwithintimescales",
              display: "Has not been notified within the timescales set out in the contract",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompensationStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "APMA",
              display: "Quote Not Accepted - $PM_ABBREVIATION to make own Assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ARQ",
              display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "AM",
              display: "$PM_ABBREVIATION Assessment Made",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "QA",
              display: "Quote Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "APMRQ",
              display: "Awaiting $PM_ABBREVIATION Response to quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "APMR",
              display: "Awaiting $PM_ABBREVIATION Response to Variation Notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "AQ",
              display: "Awaiting Quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NC",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "R",
              display: "Not a Variation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "DNG",
              display: "Decision Not Given",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "0",
              display: "Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "1",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "2",
              display: "Awaiting Response",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "3",
              display: "Not Accepted - $PM_ABBREVIATION to make assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "4",
              display: "Not Accepted - Other quote approved",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "5",
              display: "Not Accepted - Decision will not be given",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "none",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "InstructionReplyProceedOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "61.1",
              display: "$SUPPLIER_NAME is instructed to proceed with works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "61.2",
              display: "$SUPPLIER_NAME is instructed to NOT proceed with works until instructed",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "EWRelationEnabled",
          values: [
            {
              id: 1,
              isActive: false,
              field: "EWRelationEnabled",
              display: "Active-Inactive state indicates weather the EWN can be attached in CEN communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Fields",
          values: [
            {
              id: 1,
              isActive: false,
              field: "Assumption",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteProgrammeImpactOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "noeffect",
              display: "There is no effect on the Accepted Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "mitigated",
              display: "There is an effect on the Accepted Programme but this has been mitigated by measures as detailed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "notmitigated",
              display: "There is an effect on the Accepted Programme which we are unable to mitigate",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "VariationClauses",
          values: [
            {
              id: 42,
              isActive: true,
              field: "",
              display: "2.4 Additional cost in connection with the correction of an inconsistency",
              overrideResources: null,
              postActions: null
            },
            {
              id: 27,
              isActive: true,
              field: "",
              display: "3.6.1 An instruction requiring a Variation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 28,
              isActive: true,
              field: "",
              display: "5.8 Additional cost in connection with insurance work treated as a Variation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 29,
              isActive: false,
              field: "",
              display: "2.20.3 Deferment of the date of possessions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              isActive: false,
              field: "",
              display: "2.20.4 Execution of work which which an Approximate Quantity is not accurate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              isActive: false,
              field: "",
              display: "2.20.5 Suspension by the Contractor",
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              isActive: false,
              field: "",
              display: "2.20.6 Any impediment, act or omission of the Employer or related persons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              isActive: false,
              field: "",
              display: "2.20.7 an epidemic",
              overrideResources: null,
              postActions: null
            },
            {
              id: 34,
              isActive: false,
              field: "",
              display: "2.20.8 of a passing of a law or or the exercise of a statutory power",
              overrideResources: null,
              postActions: null
            },
            {
              id: 35,
              isActive: false,
              field: "",
              display: "2.20.9 the carrying out of work by a Statutory Authority",
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              isActive: false,
              field: "",
              display: "2.20.10 exceptionally adverse weather conditions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 37,
              isActive: false,
              field: "",
              display: "2.20.11 loss of damage by a Specified Peril",
              overrideResources: null,
              postActions: null
            },
            {
              id: 38,
              isActive: false,
              field: "",
              display: "2.20.12 civil commotion or terrorism",
              overrideResources: null,
              postActions: null
            },
            {
              id: 40,
              isActive: false,
              field: "",
              display: "2.20.13 strike, lock out or union activities",
              overrideResources: null,
              postActions: null
            },
            {
              id: 39,
              isActive: false,
              field: "",
              display: "2.20.14 Force majeure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              isActive: true,
              field: "",
              display: "Other Variation",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompensationClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "60.1(1) Employer has given an instruction to change the Scope",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "60.1(2) Access not provided by date stated within the contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "60.1(3) Something not provided",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "",
              display: "60.1(4) Stop or change key date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "60.1(5) Work by employer or others",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: true,
              field: "",
              display: "60.1(6) Late reply to communication",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "60.1(7) Previous decision changed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "",
              display: "60.1(8) Acceptance Withheld",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "",
              display: "60.1(9) PM corrects an assumption related to a previous compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "",
              display: "60.1(10) Breach of Contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "",
              display: "60.1(11) Prevention event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "",
              display: "60.1(12) Defect corrected which was not the Consultant’s liability",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "",
              display: "60.1(13): Instruction to change Task Order issued by Employer",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "",
              display: "60.1(14): Consultant receives late Task Order",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "60.1(15): a Task Completion Date is later than the Completion Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "",
              display: "X2.1: Change in law",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 108,
      title: "Payments",
      workflows: [
        {
          id: 20,
          title: "Payment Certificates",
          notificationName: "Payment Certificate",
          abbreviation: "$PM_ABBREVIATION-Payment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 21,
          title: "Payment Applications",
          notificationName: "Payment Application",
          abbreviation: "$SUPPLIER_ABBREVIATION-Payment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CumulativePriceLabel",
              display: "Value of Work Done",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PlusAmountsSupplierLabel",
              display: "Plus other amounts to be paid to the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "LessAmountsSupplierLabel",
              display: "Less amounts to be paid by or retained from the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "TaxSupplierLabel",
              display: "Taxes",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "WarningBanner",
              display: "During the period up to the due date for the final payment, the monthly due dates for interim payments by the Employer shall in each case be the date 7 days after the relevant Interim Valuation Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SummaryDetailsLabel",
              display: "Summary details",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaxEnabled",
          values: [
            {
              id: 1,
              isActive: false,
              field: "TaxEnabled",
              display: "Active-Inactive state indicates tax field will be included in notification forms",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "PaymentTypes",
          values: [
            {
              id: 1,
              isActive: false,
              field: "FINAL",
              display: "Final",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "INTERIM",
              display: "Interim",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "SUPPLEMENTARY",
              display: "Supplementary",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ApplicationTypes",
          values: [
            {
              id: 1,
              isActive: false,
              field: "FINAL",
              display: "Final",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "INTERIM",
              display: "Interim",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "SUPPLEMENTARY",
              display: "Supplementary",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 109,
      title: "Defects",
      workflows: [
        {
          id: 23,
          title: "Defect Notifications",
          notificationName: "Defect Notification",
          abbreviation: "$PM_NAME-Defect-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]],\"and\",[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]]",
              viewDraftFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"PM\"]]",
              communicateFilter: "[[\"rolepermissions\",\"=\",\"Manager\"],\"and\",[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]]"
            },
            actionTab: {
              actionFilter: "[[\"rolepermissions\",\"=\",\"Manager\"],\"and\",[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"rolepermissions\",\"=\",\"Manager\"],\"and\",[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]]"
            }
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Instruction",
              display: "$SUPERVISOR_NAME Instruction to Search awaiting sign off",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SuperDefect",
              display: "$SUPERVISOR_NAME Notification of Defect awaiting acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Inspection",
              display: "$SUPPLIER_NAME Test/Inspection Notification awaiting sign off",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedClauses",
          values: [
            {
              id: 3,
              wfid: 22,
              isActive: false,
              field: "",
              display: "3.14 to open work up for inspection or carry out any tests",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_24",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 1,
              wfid: 23,
              isActive: true,
              field: "",
              display: "2.10 of defects, shrinkages or other faults",
              overrideResources: null,
              postActions: []
            },
            {
              id: 2,
              wfid: 24,
              isActive: false,
              field: "",
              display: "43.2 Notification of a Defect",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "InstructionClauseLabel",
              display: "Under clause 43.1, you are instructed to search for a Defect as follows:",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SupervisorClauseLabel",
              display: "Under clause 43.2, you are notified of a Defect as follows",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "SupplierClauseLabel",
              display: "Under clause 43.2, you are notified of a Defect as follows",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "TestsClauseLabel",
              display: "Under clause 41.3, I am informing you of a test or inspection as follows:",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "DefectsWarningBanner",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SearchWarningBannerDate",
              display: "An instruction to search for a Defect is not to be issued after the defects date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "SearchWarningBannerDetails",
              display: "Reasons for the search must be included.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NCProposalReplyWarningBanner",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "NCProposalNote",
              display: "Z5.2(1) Proposal to treat a Defect as a Non-Conformity. Response will be required by $date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "ClosureReasonLabel",
              display: "Reason for closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "InstructionTypeLabel",
              display: "Type",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 111,
      title: "Records",
      workflows: [
        {
          id: 30,
          title: "A/CA Meetings",
          notificationName: "Meeting",
          abbreviation: "$PM_ABBREVIATION-Meeting-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 31,
          title: "$SUPPLIER_NAME Meetings",
          notificationName: "Meeting",
          abbreviation: "$SUPPLIER_ABBREVIATION-Meeting-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 32,
          title: "$SUPPLIER_NAME Site Diary",
          notificationName: "Site Diary",
          abbreviation: "Diary-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 33,
          title: "Weather",
          notificationName: "Weather",
          abbreviation: "Weather-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: []
    },
    {
      id: 112,
      title: "RFI / TQ",
      workflows: [
        {
          id: 34,
          title: "$SUPPLIER_NAME RFI / TQ",
          notificationName: "RFI / TQ",
          abbreviation: "RFI/TQ-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$SUPPLIER_NAME RFI/TQ awaiting Reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 101,
      title: "Early Dispute Resolution",
      workflows: [
        {
          id: 1,
          title: "A/CA EDR Notices",
          notificationName: "Early Dispute Resolution",
          abbreviation: "$PM_ABBREVIATION-Warning-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Support\"]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 2,
          title: "$SUPPLIER_NAME EDR Notes",
          notificationName: "Early Dispute Resolution",
          abbreviation: "$SUPPLIER_ABBREVIATION-Warning-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Support\"]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 3,
          title: "EDR Register",
          notificationName: "Early Dispute Resolution",
          abbreviation: "Warning",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "MeetingRequiredLabel",
              display: "Is a meeting required?",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "NotificationClause",
              display: "You are hereby notified of",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "RiskItemsLabel",
              display: "",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Pm",
              display: "$PM_ABBREVIATION EDR awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Supplier",
              display: "$SUPPLIER_NAME EDR awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RiskTypes",
          values: [
            {
              id: 2,
              isActive: true,
              field: "riskother",
              display: "a matter which is likely to give rise to a dispute",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "riskaffectwork",
              display: "Sch 5.1 of behaviour which is not collaborative",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RiskTypesSupplier",
          values: [
            {
              id: 2,
              isActive: true,
              field: "riskother",
              display: "a matter which is likely to give rise to a dispute",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "riskaffectwork",
              display: "Sch 5.1 of behaviour which is not collaborative",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "MeetingOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "0",
              display: "Meeting Not Required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "1",
              display: "Meeting Required - Next Progress Meeting",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "2",
              display: "Meeting Required - Propose New Progress Meeting",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 113,
      title: "Contract Information",
      workflows: [
        {
          id: 39,
          title: "Documents",
          notificationName: "Document",
          abbreviation: "Documents-",
          notify: true,
          actioningParty: "PM",
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            }
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: []
        }
      ]
    },
    {
      id: 117,
      title: "Other Certificates (excluding payments)",
      workflows: [
        {
          id: 68,
          title: "$PM_NAME Certificates",
          notificationName: "Certificate",
          abbreviation: "$PM_ABBREVIATION-Certificate-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 69,
          title: "$SUPPLIER_NAME Certificates",
          notificationName: "Certificate",
          abbreviation: "$SUPPLIER_ABBREVIATION-Certificate-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
          }
        },
        {
          id: 70,
          title: "$CLIENT_NAME Certificates",
          notificationName: "Certificate",
          abbreviation: "$CLIENT_ABBREVIATION-Certificate-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "CLIENT_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "CLIENT",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Client\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Client\"]",
              communicateFilter: "[[\"party\",\"=\",\"Client\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"PM\"]]"
          }
        },
        {
          id: 71,
          title: "$SUPERVISOR_NAME Certificates",
          notificationName: "Certificate",
          abbreviation: "$SUPERVISOR_ABBREVIATION-Certificate-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPERVISOR_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPERVISOR",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Supervisor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Supervisor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SupplierCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "ClientCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "SupervisorCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PM",
              display: "$WF_68_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Supplier",
              display: "$WF_69_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Client",
              display: "$WF_70_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Supervisor",
              display: "$WF_71_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Completion Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SectionalCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Sectional Completion Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TakingOverFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Taking Over Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "DefectsFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TerminationFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "OtherFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaskOrderStartFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaskOrderCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ProjectOrderStartFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ProjectOrderCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Accepted",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Not Accepted",
              display: "Not Accepted",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "PMCertTypes",
          values: [
            {
              id: 1,
              isActive: true,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "",
              display: "Task Order starting date",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "Task Completion Date",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "Project Order starting date",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "Project Completion Date",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SupplierCertTypes",
          values: [
            {
              id: 1,
              isActive: false,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "",
              display: "Task Order Start",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "Project Order Start",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ClientCertTypes",
          values: [
            {
              id: 1,
              isActive: false,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "",
              display: "Task Order Start",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "Project Order Start",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SupervisorCertTypes",
          values: [
            {
              id: 1,
              isActive: false,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "",
              display: "Task Order Start",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "Project Order Start",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompletionChangesStateEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CompletionChangesStateEnabled",
              display: "Indicate whether communication of a Completion Certificate should change the contract state",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedReplyOptions",
          values: [
            {
              id: 1,
              wfid: 68,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 68,
              isActive: true,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 68,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 68,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_68",
                  timePeriod: "PM_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 5,
              wfid: 68,
              isActive: true,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              wfid: 69,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              wfid: 69,
              isActive: true,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              wfid: 69,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              wfid: 69,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_69",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 10,
              wfid: 69,
              isActive: true,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              wfid: 70,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              wfid: 70,
              isActive: true,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              wfid: 70,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              wfid: 70,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "CLIENT",
                  actionType: "WF_70",
                  timePeriod: "CLIENT_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 15,
              wfid: 70,
              isActive: true,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              wfid: 71,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              wfid: 71,
              isActive: true,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              wfid: 71,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              wfid: 71,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPERVISOR",
                  actionType: "WF_71",
                  timePeriod: "SUPERVISOR_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 20,
              wfid: 71,
              isActive: true,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedClauses",
          values: [
            {
              id: 1,
              wfid: 68,
              isActive: true,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 68,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 68,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 68,
              isActive: true,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              wfid: 68,
              isActive: false,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              wfid: 68,
              isActive: true,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              wfid: 68,
              isActive: false,
              field: "",
              display: "Task Order Start",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              wfid: 68,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              wfid: 68,
              isActive: false,
              field: "",
              display: "Project Order Start",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              wfid: 68,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              wfid: 69,
              isActive: true,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Task Order Start",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Project Order Start",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              wfid: 69,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 22,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 23,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 24,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              wfid: 70,
              isActive: true,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              wfid: 70,
              isActive: true,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 27,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Task Order Start",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 28,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 29,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Project Order Start",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              wfid: 70,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 34,
              wfid: 71,
              isActive: true,
              field: "",
              display: "Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 35,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 37,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Task Order Start",
              effect: "TASK_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 38,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 39,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Project Order Start",
              effect: "PROJECT_ORDER_START",
              overrideResources: null,
              postActions: null
            },
            {
              id: 40,
              wfid: 71,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    }
  ]
};
export default template;